<template lang="pug">
  div
    span(class="headline") Reports

    v-container
      sites
      franchises(class="mt-3")
      perf(class="mt-3")
      jobs(class="mt-3")
      material(class="mt-3")
      material-history(class="mt-3")
      snags(class="mt-3")

</template>

<script>
import Franchises from "./Reports/Franchises.vue";
import Jobs from "./Reports/Jobs.vue";
import Material from "./Reports/Material.vue";
import MaterialHistory from "./Reports/MaterialHistory.vue";
import Perf from "./Reports/Performance.vue";
import Sites from "./Reports/Sites.vue";
import Snags from "./Reports/Snags.vue";

export default {
  name: "reports",
  components: {
    Franchises,
    Jobs,
    Material,
    MaterialHistory,
    Perf,
    Sites,
    Snags
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reports.vue